/**
 * Mutation observers to find changes to element classes or other attributes,
 * and make changes to other DOM elements based on it.
 * @author Amal Ajith
 */

import {changeCgGlobalLangIcon, changeCgLogoDesktop, changeCgLogoMobile} from "./logoChanger";

/**
 * Observer for mutation events in headerTopBar element
 */
export const headerMutationObserver = () => {

    /**
     * Get the headerTopBarNode element
     * @type {HTMLElement}
     */
    const headerTopBarNode = document.querySelector('.header-topbar');
    const headerTopBarWrapperNode = document.querySelector('.header-topbar-wrapper');

    // Options for the observer (which mutations to observe)
    const classMutationConfig = { attributes: true, attributesFilter: ['class'] };


    /**
     * Callback function when a mutation happens.
     * We are looking for 2 mutations, fixed class, hover class and background-color changing to white.
     * @param mutationsList
     * @param observer
     * @type {MutationCallback}
     */
    const classMutationCallback = (mutationsList, observer) => {

        for(const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                const observingClassNames = ['fixed', 'hover']
                if(observingClassNames.some(className => mutation.target.classList.contains(className))){
                    //Always blue logo when headerTop background is white
                    changeCgLogoDesktop('blue');
                    changeCgGlobalLangIcon('black');
                } else {
                    if(headerTopBarWrapperNode.classList.contains('dark-gradient')){
                        changeCgLogoDesktop('white');
                        changeCgGlobalLangIcon('white');
                    } else {
                        changeCgLogoDesktop('blue');
                        changeCgGlobalLangIcon('black');
                    }
                }
            }
        }
    }

    /**
     * Class mutation observer
     * @type {MutationObserver}
     */
    const observer = new MutationObserver(classMutationCallback);

    //Observe for class mutations
    observer.observe(headerTopBarNode, classMutationConfig);

    // If page loads with .fixed class
    if(headerTopBarNode.classList.contains('fixed')){
        changeCgLogoDesktop('blue');
    }

}

export const headerMobileMutationObserver = () => {

    /**
     * Get the headerMobileBar element
     * @type {HTMLElement}
     */
    const headerMobileBarNode = document.querySelector('.header-mobile-bar');

    /**
     * Get the headerMobile element
     * @type {HTMLElement}
     */
    const headerMobileNode = document.querySelector('.header-mobile');

    // Options for the observer (which mutations to observe)
    const classMutationConfig = { attributes: true, attributesFilter: ['class'] };

    const classMutationCallback = (mutationsList, observer) => {

        for(const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                const observingClassNames = ['opened']
                if(observingClassNames.some(className => mutation.target.classList.contains(className))){
                    //Always blue logo when headerTop background is white
                    changeCgLogoMobile('blue');
                    changeCgGlobalLangIcon('black');
                } else {
                    if(headerMobileNode.classList.contains('dark-gradient')){
                        changeCgLogoMobile('white');
                        changeCgGlobalLangIcon('white');
                    } else {
                        changeCgLogoMobile('blue');
                        changeCgGlobalLangIcon('black');
                    }
                }
            }
        }
    }

    /**
     * Class mutation observer
     * @type {MutationObserver}
     */
    const observer = new MutationObserver(classMutationCallback);

    //Observe for class mutations
    observer.observe(headerMobileBarNode, classMutationConfig);

}


export const menuOpenMutationObserver = () => {
    const headerTopBarNode = document.querySelector('.header-topbar');

    const subNavigationNode = document.querySelector('.sub-navigation-wrapper');

    // Options for the observer (which mutations to observe)
    const classMutationConfig = { attributes: true, attributesFilter: ['class'] };

    const classMutationCallback = (mutationsList, observer) => {

        for(const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
                const observingClassName = 'menu-open';
                if(mutation.target.classList.contains(observingClassName)) {
                    if(subNavigationNode){
                        subNavigationNode.classList.add('below-header');
                    }
                    if(headerTopBarNode) {
                        headerTopBarNode.classList.add('hover');
                    }
                } else {
                    if(subNavigationNode) {
                        if(!$( '.header-lang' ).hasClass( 'active' )){
                            subNavigationNode.classList.remove('below-header');
                        }
                    }
                }
            }
        }
    }

    /**
     * Class mutation observer
     * @type {MutationObserver}
     */
    const observer = new MutationObserver(classMutationCallback);

    const subNavNodes = headerTopBarNode.querySelectorAll('.menu-submenu');

    subNavNodes.forEach((el) => {
        observer.observe(el, classMutationConfig);
    })


}

